export default __webpack_public_path__ + "static/media/seashell5.b2fd3971.svg";